export default __webpack_public_path__ + "static/chip_art-04@2x_1-d0c6ad336f3db1feb2c48b5850d6635e.jpeg";